/**
 * Pass service id from service detail → /find-workshop without putting it in the URL.
 * Read on the find-workshop page removes sessionStorage; an in-memory memo survives
 * React Strict Mode’s double layout effect so the id is not lost on the second run.
 */
export const FIND_WORKSHOP_PENDING_SERVICE_KEY =
  "petromin_find_workshop_service_id";

/** Last value taken from sessionStorage this SPA session; cleared when leaving /find-workshop. */
let pendingServiceMemo: string | null | undefined = undefined;

export function stashFindWorkshopServiceId(serviceId: string): void {
  pendingServiceMemo = undefined;
  try {
    const id = serviceId.trim();
    if (!id) return;
    sessionStorage.setItem(FIND_WORKSHOP_PENDING_SERVICE_KEY, id);
  } catch {
    /* private mode / SSR */
  }
}

/** Cleared when the user navigates away from /find-workshop (see FindWorkshopSessionRouteSync). */
export function clearFindWorkshopServiceIdMemo(): void {
  pendingServiceMemo = undefined;
}

/** Returns stored id and clears sessionStorage; memo replays on repeat reads (e.g. Strict Mode). */
export function takeFindWorkshopServiceId(): string | null {
  try {
    const v = sessionStorage.getItem(FIND_WORKSHOP_PENDING_SERVICE_KEY)?.trim();
    if (v) {
      sessionStorage.removeItem(FIND_WORKSHOP_PENDING_SERVICE_KEY);
      pendingServiceMemo = v;
      return v;
    }
  } catch {
    /* ignore */
  }

  if (pendingServiceMemo !== undefined) {
    return pendingServiceMemo;
  }
  return null;
}
